enum KakaoPixelType {
  CREATE_LEAD = 'create lead',
  PLACE_ORDER = 'place order',
  DONE = 'done',
}

export default KakaoPixelType
